import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import { FONT_SIZE_TOKENS } from './typeScale'

// Spec 159 — tailwind-merge doit connaître les jetons de taille de la charte (`text-caption`, `text-small`…) : sans
// cela, il les prend pour des couleurs de texte et efface l'un ou l'autre (garde : `utils.test.ts`).
const twMerge = extendTailwindMerge({
  extend: { theme: { text: [...FONT_SIZE_TOKENS] } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
